import { useContext, } from "react";
import AlertContext, { AlertContextProps, } from "contexts/AlertContext";

const useAlert = () : AlertContextProps => useContext(AlertContext);

export default useAlert;
